<template>
  <div class="text-center">
    <v-overlay v-model="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
      <br>
      <br>
      <h2 v-if="message != null" class="font-weight-medium">{{ message }}</h2>
    </v-overlay>
  </div>
</template>

<script>
  export default {
    name: 'Loading',

    props: {
      loading: {
        type: Boolean, 
        default: false
      },
      message: {
        type: String, 
        default: null
      },
      color: {
        type: String, 
        default: 'purple'
      },
    },
  }
</script>